import type { ExtensionsConfigOptions } from '../../types';

export const extConfig: ExtensionsConfigOptions = {
  bold: true,
  italic: true,
  strikethrough: true,
  underline: true,
  bulletList: true,
  orderedList: true,
  horizontalRuler: true,
  link: true,
  emote: true,
  gif: {
    defaultWidth: 780,
    canAlign: true,
    defaultAlignment: 'center',
  },
  deviation: {
    defaultWidth: Infinity,
    formMaxWidth: 1920,
    canAlign: true,
    canLink: true,
  },
  deviationThumb: {
    defaultWidth: 150,
    canLink: true,
    maxHeight: 600,
    maxWidth: 780,
  },
  allowUploads: true,
  daVideo: false,
  gallery: false,
  anchor: true,
  spinner: true,
  blockDragging: false,
  blockquote: true,
  heading: true,
  hashtag: true,
  mention: true,
  paste: true,
  textAlignment: true,
  textColor: true,
  textFont: true,
  textHighlight: true,
  history: true,
  indent: {
    captureTab: true,
  },
  muro: true,
  characterCount: false,
};
